import { render, staticRenderFns } from "./pos-drawer.vue?vue&type=template&id=73efe914&scoped=true"
import script from "./pos-drawer.vue?vue&type=script&lang=js"
export * from "./pos-drawer.vue?vue&type=script&lang=js"
import style0 from "./pos-drawer.vue?vue&type=style&index=0&id=73efe914&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73efe914",
  null
  
)

export default component.exports